<template>
  <div class="admin">
    <aside>
      <Sidebar @modalClicked="handleModalClick"></Sidebar>
    </aside>
    <main class="main">
      <Navbar @open="triggerModal"></Navbar>
      <Settings v-if="isOpen" @close="triggerModal" />
      <Modal
        v-if="isModalOpened"
        :modalParams="modalParams"
        @close="handleModalClose"
      />
      <router-view
        :key="key"
        @showModal="handleModalClick"
        @close="isModalOpened = !isModalOpened"
      ></router-view>
    </main>
  </div>
</template>

<script>
import Navbar from "@/modules/admin/elements/Navbar";
import Settings from "@/components/Settings";
import Sidebar from "@/modules/admin/elements/Sidebar";
import Modal from "@/modules/admin/elements/Modal";

export default {
  name: "admin",
  components: {
    Navbar,
    Sidebar,
    Settings,
    Modal
  },
  data: () => ({
    key: "Admin",
    isOpen: false,
    isModalOpened: false,
    modalParams: null
  }),
  methods: {
    triggerModal() {
      this.isOpen = !this.isOpen;
    },
    handleModalClick(params) {
      this.modalParams = params;
      this.isModalOpened = true;
    },
    handleModalClose(params = { hasBackdropEvent: true }) {
      if (params.hasBackdropEvent == false) return;

      this.isModalOpened = !this.isModalOpened;
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  @media (min-width: 1200px) {
    max-width: 1366px;
  }
}
.admin {
  position: relative;
  @media screen and (max-width: 1199px) {
    overflow: hidden;
  }
  aside {
    background-color: $white;
    border-right: 1px solid $gray-200;
    bottom: 0;
    left: 0;
    min-height: 100vh;
    padding: 20px;
    position: fixed;
    top: 0;
    width: 225px;
    @media (max-height: 755px) {
      overflow: auto;
    }
  }
  .main {
    margin-left: 225px;

    @media screen and (max-width: 1199px) {
      overflow: hidden;
    }
  }
}
.form-material {
  & > .form-control {
    box-shadow: 0 1px 0 $gray-500;
    font-family: "Gotham";
  }
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.2s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>

<style lang="scss">
@media print {
  aside {
    display: none !important;
  }
  .admin {
    .main {
      margin-left: 0 !important;
      .header {
        display: none !important;
      }
    }
  }
}
</style>
